import { render, staticRenderFns } from "./PieColor.vue?vue&type=template&id=2cfdea78&"
import script from "./PieColor.vue?vue&type=script&lang=js&"
export * from "./PieColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cfdea78')) {
      api.createRecord('2cfdea78', component.options)
    } else {
      api.reload('2cfdea78', component.options)
    }
    module.hot.accept("./PieColor.vue?vue&type=template&id=2cfdea78&", function () {
      api.rerender('2cfdea78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/PieColor.vue"
export default component.exports